import { FormSelectSelectionLabel } from '../../../common/form/input/FormSelectSelectionLabel';
import { encodeStringKey } from '../../../common/utils';
import { AlgorithmSource, getAlgorithmSourceShortLabel } from '../utils';
import type { AlgorithmMappingQueryDtoType } from './schema/types';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './utils.translations.json';

const { addTranslations, t } = i18nNsFactory('algorithm-mappings-utils');
addTranslations(translations);

export function getAlgorithmMappingLabel(
  mapping: AlgorithmMappingQueryDtoType,
  sourcesById: Map<number, AlgorithmSource>,
) {
  const {
    alias,
    algorithmSourceId,
    sourceDimension,
    joinTypeCode,
    classifierMappingCode,
    dataObjectDescriptionCode,
  } = mapping;

  const algorithmSource = sourcesById.get(algorithmSourceId || 0);
  const sourceLabel = getAlgorithmSourceShortLabel(algorithmSource);
  let descriptionCode = '';
  if (dataObjectDescriptionCode) {
    if (sourceLabel) {
      descriptionCode += ' ';
    }
    descriptionCode = dataObjectDescriptionCode + '.';
  }

  return `${alias + ' | '}${sourceLabel}${descriptionCode}${
    sourceDimension + ' '
  }${joinTypeCode + ' '}${classifierMappingCode}`;
}

export const createAlgorithmMappingsOptionGroup = (
  mappings: AlgorithmMappingQueryDtoType[],
) => {
  const mappingsLabel = t('algorithm-mappings-option-group-label');

  return {
    key: mappingsLabel,
    label: mappingsLabel,
    options: mappings.map((mapping) => {
      const key = encodeAlgorithmMappingOptionValue(mapping.alias);
      return {
        key,
        value: key,
        mapping,
        label: mapping.alias,
        displayLabel: (
          <FormSelectSelectionLabel supertitle={mappingsLabel}>
            {mapping.alias}
          </FormSelectSelectionLabel>
        ),
      };
    }),
  };
};

export const encodeAlgorithmMappingOptionValue = (mappingAlias = '') =>
  encodeStringKey('mapping', mappingAlias);
